const headerSelector = '.transparent-header header > .e-div, .error404 header > .e-div';
const mainSelector = 'main, .entry-content, .e-stn--404-section, .e-stn--404';

function appendProgressiveBlurLayers() {
  const headerTag = document.querySelector( '.transparent-header header, .error404 header' );
  if ( !headerTag ) return;

  if ( headerTag.querySelector( '.blur-layer' ) || headerTag.querySelector( '.gradient-overlay' ) ) {
    return;
  }

  const fragment = document.createDocumentFragment();

  for ( let i = 1; i <= 8; i++ ) {
    const blurLayer = document.createElement( 'div' );
    blurLayer.className = `blur-layer blur-${ i }`;
    fragment.appendChild( blurLayer );
  }

  const gradientOverlay = document.createElement( 'div' );
  gradientOverlay.className = 'gradient-overlay';
  fragment.appendChild( gradientOverlay );

  headerTag.appendChild( fragment );
}

function setMainMarginTop() {
  const header = document.querySelector( headerSelector );
  const main = document.querySelector( mainSelector );
  if ( header && main ) {
    main.style.setProperty( 'margin-top', -header.offsetHeight + 'px', 'important' );
  }
}

document.addEventListener( 'DOMContentLoaded', function() {
  appendProgressiveBlurLayers();
  setMainMarginTop();

  const header = document.querySelector( headerSelector );
  if ( header ) {
    const resizeObserver = new ResizeObserver( () => {
      setMainMarginTop();
    } );
    resizeObserver.observe( header );
  }
} );

window.onresize = function() {
  setMainMarginTop();
};